import request from '@/utils/request'
import {encrypt} from "@/utils/encrypt";
import {dealDownloadFileResponse} from "@/api/file";

export function getDistributorList({userId,distributorKey='',finalUserKey=''}) {
    // console.log('abc')
    return request({
        url: `/appi/Operate/GetDistributorList?userId=${encrypt(userId)}&distributorKey=${distributorKey}&finalUserKey=${finalUserKey}`
    })

}

export function getFinalUserList({userId,distributorCode='',finalUserKey=''}) {
    // console.log('abc')
    return request({
        url: `/appi/Operate/GetFinalUserList?userId=${encrypt(userId)}&distributorCode=${distributorCode}&finalUserKey=${finalUserKey}`
    })

}

export function getCallLog({userId,sDate='',eDate='',key='',range='0'}) {
    // console.log('abc')
    return request({
        url: `/appi/Operate/GetCallLog?userId=${encrypt(userId)}&sDate=${sDate}&eDate=${eDate}&key=${key}&range=${range}`
    })

}

export function SaveEmailLog({
    userId, emailId, title='', content='', fromEmail='', toEmail='', sendTime='', sheetCode='', sample = ''}) {
return request({
    url: `/appi/Interface/SaveEmailLog`, data: {uId: userId, emailId, title, content, fromEmail, toEmail, sendTime, sheetCode,sample}});
}


export function EmailLogList({userId,emailId='',sDate='',eDate='',key=''}) {
    // console.log('abc')
    return request({
        url: `/appi/Operate/EmailLogList?userId=${encrypt(userId)}&emailId=${emailId}&sDate=${sDate}&eDate=${eDate}&key=${key}`
    })

}
export function EmailDelete({userId,  emailId}) {
    return request({url: `/appi/Interface/DeleteEmailLog?userId=${encrypt(userId)}&emailId=${emailId}`})
}


export function SetSheetCode({userId,  CallSheetId, sheetCode}) {
    return request({url: `/appi/Interface/SetSheetCode?uId=${userId}&CallSheetId=${CallSheetId}&sheetCode=${sheetCode}`})
}

export function SetCompanyName({userId,  CallSheetId, companyName}) {
    return request({url: `/appi/Interface/SetCompanyName?uId=${userId}&CallSheetId=${CallSheetId}&companyName=${companyName}`})
}

/**
 * 导出邮件列表
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
 export function EmailLogListExport({userId,emailId='',sDate='',eDate='',key=''}) {
    return request({
        url: `/appi/Operate/EmailLogListExport?userId=${encrypt(userId)}&emailId=${emailId}&sDate=${sDate}&eDate=${eDate}&key=${key}`,
        method: 'get',
        responseType: 'blob'
    }).then(res => {
        console.log(res);
        return dealDownloadFileResponse({res});
    })
}



/**
 * 导出通话列表
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
 export function CallLogListExport({userId,sDate='',eDate='',key='',range='0'}) {
    return request({
        url: `/appi/Operate/GetCallLogExport?userId=${encrypt(userId)}&sDate=${sDate}&eDate=${eDate}&key=${key}&range=${range}`,
        method: 'get',
        responseType: 'blob'
    }).then(res => {
        console.log(res);
        return dealDownloadFileResponse({res});
    })
}